import { render, staticRenderFns } from "./home_whiteboard.vue?vue&type=template&id=5b2947a9&scoped=true"
import script from "./home_whiteboard.vue?vue&type=script&lang=js"
export * from "./home_whiteboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2947a9",
  null
  
)

export default component.exports